import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { NotificationManager } from "react-notifications";
import { useMediaQuery } from 'react-responsive'

import { sendResetPasswordCredentials } from "../../store/actions";
import PlaceholderImage from "../../sharedComponents/placeholderImage";
import Logo from "../../assets/images/logo-color.png";
import { FormField } from "../../sharedComponents/formField";
import { queryStringToJSON } from "../../utils/common";
import { resetPasswordFormFieldList } from "../../constants/session";

const ResetPassword = ({ history, match, handleSubmit, sendResetPasswordCredentials }) => {
	const [token, setToken] = useState(null);

	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 991px)' });

	useEffect(() => {
		history && history.location && history.location.search && queryStringToJSON(history.location.search).token
			? setToken(queryStringToJSON(history.location.search).token)
			: history.push("/signin");
	}, [history]);

	const submitResetPassword = (values) => {
		const successHandler = (event) => {
			NotificationManager.success("Password changed successfully. Please login again!", "", 5000);
			history.push("/signin");
		};
		const errorHandler = (event) => {
			event && event.error_code === "NOT_FOUND" && NotificationManager.error("Invalid token!", "", 5000);
		};
		sendResetPasswordCredentials({ ...values, token }, successHandler, errorHandler);
	};

	return (
		<section className="page page-session">
			{!isTabletOrMobile ? (
				<div className="session-wrap">
					<div className="session-left">
						<div className="left-data-container">
							<h2 className="normal">Membership with benefits!</h2>
							<p>FREE for active patients in our program.</p>
							<ul className="check-list">
								<li>Your weight statistics with charts</li>
								<li>Access to various exercises</li>
								<li>Food nutrient database</li>
								<li>Approved recipes</li>
								<li>Customizable profile</li>
								<li>Articles, information, tips, and more!</li>
							</ul>
						</div>
					</div>
					<div className="session-right">
						<PlaceholderImage src={Logo} />
						<form className="m-0" onSubmit={handleSubmit(submitResetPassword)}>
							{resetPasswordFormFieldList &&
								resetPasswordFormFieldList.length > 0 &&
								resetPasswordFormFieldList.map(({ type, name, label, validate }, index) => {
									return (
										<Field
											key={index}
											label={label}
											name={name}
											type={type}
											formGroupClass="no-label mt-3"
											component={FormField}
											validate={validate}
										/>
									);
								})}
							<button type="submit" className="w-100 btn btn-primary btn-lg text-uppercase">
								Submit
							</button>
						</form>
						<div className="text-right mt-2 mb-5">
							<Link to="/signin" className="text-secondary">
								Login
							</Link>
						</div>
					</div>
				</div>
			) : (
				<div className="session-wrap">
					<div className="session-right" style={{margin: '0 auto', textAlign: 'center'}}>
						<PlaceholderImage src={Logo} />
						<form className="m-0" onSubmit={handleSubmit(submitResetPassword)}>
							{resetPasswordFormFieldList &&
								resetPasswordFormFieldList.length > 0 &&
								resetPasswordFormFieldList.map(({ type, name, label, validate }, index) => {
									return (
										<Field
											key={index}
											label={label}
											name={name}
											type={type}
											formGroupClass="no-label mt-3"
											component={FormField}
											validate={validate}
										/>
									);
								})}
							<button type="submit" className="w-100 btn btn-primary btn-lg text-uppercase">
								Submit
							</button>
						</form>
						<div className="text-right mt-2 mb-5">
							<Link to="/signin" className="text-secondary">
								Login
							</Link>
						</div>
					</div>
				</div>
			)}
		</section>
	);
};

const mapDispatchToProps = {
	sendResetPasswordCredentials
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "ResetPasswordForm"
	})(ResetPassword)
);
